"use client"

import React from "react"
import { LayoutDashboard, Users, Store, Truck, ShoppingBag, BarChart3, Settings, Bell, Tag, Star, UtensilsCrossed, CreditCard, UserCircle, DollarSign, Image, Send, Shield } from "lucide-react"
import { useAuth } from "../contexts/AuthContext"
import { useLanguage } from "../contexts/LanguageContext"
import { useNewOrders } from "../contexts/NewOrderContext"
import AdminSidebar from "./ui/dashboard/AdminSidebar"
import TurboLogoIcon from "./TurboLogoIcon"

interface SidebarProps {
  onClose?: () => void
}

const Sidebar: React.FC<SidebarProps> = ({ onClose }) => {
  const { logout } = useAuth()
  const { t } = useLanguage()
  const { newOrderCount } = useNewOrders()

  const groups = [
    {
      title: t("overview"),
      items: [
        { path: "/admin/dashboard", icon: LayoutDashboard, label: t("dashboard") },
        { path: "/admin/analytics", icon: BarChart3, label: t("analytics") },
        { path: "/admin/notifications", icon: Bell, label: t("notifications") },
      ]
    },
    {
      title: t("operations"),
      items: [
        { path: "/admin/orders", icon: TurboLogoIcon, label: t("deliveryOrders"), badge: newOrderCount },
        { path: "/admin/restaurants", icon: Store, label: t("restaurants") },
        { path: "/admin/captains", icon: Truck, label: t("captains") },
        { path: "/admin/customers", icon: UserCircle, label: t("customers") },
      ]
    },
    {
      title: t("management"),
      items: [
        { path: "/admin/food-items", icon: UtensilsCrossed, label: t("foodItems") },

        { path: "/admin/financials", icon: DollarSign, label: t("financials") || "Financials" },
        { path: "/admin/subscriptions", icon: CreditCard, label: t("subscriptions") || "Subscriptions" },
      ]
    },
    {
      title: t("marketing"),
      items: [
        { path: "/admin/promotions", icon: Tag, label: t("promotions") },
        { path: "/admin/banners", icon: Image, label: t("banners") || "Banners" },
        { path: "/admin/push-notifications", icon: Send, label: t("pushNotifications") || "Push Notifications" },
        { path: "/admin/feedback", icon: Star, label: t("feedback") },
      ]
    },
    {
      title: t("system"),
      items: [
        { path: "/admin/users-roles", icon: Shield, label: t("usersRoles") || "Users & Roles" },
        { path: "/admin/users", icon: Users, label: t("users") },
        { path: "/admin/settings", icon: Settings, label: t("settings") },
      ]
    }
  ]

  return (
    <AdminSidebar
      groups={groups}
      title="Turbo Delivery"
      subtitle={t("adminPanel")}
      onLogout={logout}
      onClose={onClose}
      logoColor="#DC2626"
    />
  )
}

export default Sidebar
